import BaseApiRequest from "./BaseApiRequest";
import { URL_KYC_PLAID_EMAIL } from "../ApiUrls";
import { METHOD } from "../Constants";
import { getCurrentUserParameters } from "../../Utils/CommonUtilities";

export default class KycPlaidEmailRequest extends BaseApiRequest {
  method = METHOD.HTTP.POST;

  body = {};

  url = URL_KYC_PLAID_EMAIL;

  constructor(requestData) {
    super();
    this.body = requestData;
  }

  getMethod = () => this.method;

  getUrl = () => getCurrentUserParameters(this.url);

  getBody = () => this.body;
}
